<template>
	<v-text-field
		:modelValue="text"
		:label="label"
		:placeholder="placeholder ?? $t('Select date range')"
		:readonly="true"
		variant="underlined"
		:error="error"
		:errorMessages="errorMessages"
		:density="density"
		:hide-details="hideDetails"
		class="app-activator-of-date-range-picker"
	>
		<template v-slot:append-inner>
			<ao-icon
				iconName="calendarView"
				class="align-self-center"
			/>
		</template>
	</v-text-field>
</template>

<script setup>
defineProps({

	modelValue: {
		type: Boolean,
	},

	text: {
		type: String,
		default: () => (null),
	},

	label: {
		type: String,
	},

	placeholder: {
		type: String,
	},

	error: {
		type: Boolean,
		default: false,
	},

	errorMessages: {
		type: [Array, String],
		default: () => ([]),
	},

	density: {
		type: String,
		default: 'default',
	},

	hideDetails: {
		type: [Boolean, String],
		default: false,
	},
})

defineEmits({
	'update:modelValue': null,
})
</script>

<style lang="scss">

</style>
